import React, { Fragment } from "react";
import i18next from "i18next";
import { Repeat, RepeatTiny } from "../../../StyledComponents/Repeat";
import { VisualHeading } from "../../../StyledComponents/Heading";
import Leasing from "./Leasing";
import Loan from "./Loan";
import { FinancialOption } from "../../../@types/codegen/types";
import { CreditorDisclaimer } from "../../../StyledComponents/CreditorDisclaimer";
import { getMarketCode } from "../../../utils/market";

interface FinancialOptionsProps {
  id: string;
  financialOptions: FinancialOption[];
}

const FinancialOptions = ({ id, financialOptions }: FinancialOptionsProps) => {
  const marketCode = getMarketCode();

  const hasLoanOption = financialOptions.some(
    (option) => option.type === "loan"
  );
  const showCreditorDisclaimer = marketCode === "SE" && hasLoanOption;

  return (
    <Repeat>
      <RepeatTiny>
        <VisualHeading>
          {i18next.t("item.financialOptions.otherFinancialOptions")}
        </VisualHeading>
      </RepeatTiny>
      <RepeatTiny>
        {financialOptions.map((financialOption, index) => (
          <Fragment key={index}>
            {(financialOption.type === "leasing" ||
              financialOption.type === "business-leasing") && (
              <Leasing financialOption={financialOption} />
            )}
            {financialOption.type === "loan" && (
              <Loan id={id} financialOption={financialOption} />
            )}
          </Fragment>
        ))}
      </RepeatTiny>
      {showCreditorDisclaimer && (
        <RepeatTiny>
          <CreditorDisclaimer />
        </RepeatTiny>
      )}
    </Repeat>
  );
};

export default FinancialOptions;
